import { ReactNode, useMemo } from "react";
import HttpClientProvider, { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { useOidcUser } from "../../auth/components/OidcUserProvider";
import { useBrandAuthConfig } from "../../configuration/components/BrandAuthConfigProvider";
import { getBearerAuthHeader, getDiscoveryBaseUrl } from "../utils/utils";

interface Props {
    children?: ReactNode;
}

function DiscoveryBaseUrlWithBearerAuthHeaderInterceptor(props: Props) {
    const brandAuthConfig = useBrandAuthConfig();
    const oidcUser = useOidcUser();
    const http = useHttpClient();

    const _httpClient = useMemo(() => {
        const _http = http.clone();

        _http.addRequestInterceptor(config => {
            config.baseURL = getDiscoveryBaseUrl(brandAuthConfig);

            const headers = config.headers || {};
            headers['Authorization'] = getBearerAuthHeader(oidcUser.value!)
            config.headers = headers;

            return config;
        });

        return _http;
    }, [http, brandAuthConfig, oidcUser])

    return (
        <HttpClientProvider httpClient={_httpClient}>
            {props.children}
        </HttpClientProvider>
    )
}

export default DiscoveryBaseUrlWithBearerAuthHeaderInterceptor;